module.exports = __webpack_public_path__ + "static/img/img-3.9de9900.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zbqfBrand/img-3.jpg
// module id = a3Wd
// module chunks = 0